import styled from 'styled-components';

export const CloseBackground = styled.div<types.IStyledProps>`
	height: 100%;
	position: absolute;
	width: 100%;
	z-index: 2;
`;
